// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../reason/next/Next.bs.js");
var React = require("react");
var Loader = require("../uikit/reason/atoms/Loader/Loader.bs.js");
var V4 = require("uuid/v4");
var UserSession = require("../reason/common/UserSession/UserSession.bs.js");
var SystemMessages = require("../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function UnauthenticatedComponentRelay(props) {
  var match = SystemMessages.useSystemMessages();
  var addMessage = match.addMessage;
  var initState = UserSession.useInitState();
  var router = Next.useRouter();
  React.useEffect((function () {
          var exit = 0;
          switch (initState) {
            case "Agent" :
            case "Client" :
                exit = 1;
                break;
            default:
              
          }
          if (exit === 1) {
            Next.Router.push("/", undefined, undefined, router);
            addMessage(SystemMessages.Message.make(V4(), "info", "You need to be logged out to view this page", 5000, undefined, undefined));
          }
          
        }), [initState]);
  switch (initState) {
    case "Loading" :
        return JsxRuntime.jsx(Loader.make, {});
    case "Unauthenticated" :
        return props.renderWrappedComponent();
    default:
      return null;
  }
}

var make = UnauthenticatedComponentRelay;

exports.make = make;
/* Next Not a pure module */
